// extracted by mini-css-extract-plugin
export default {"container":"x_vnsW","title":"lrBcCn","text":"LAFABE"};